import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=77754d3c&scoped=true"
import script from "./bankInfo.vue?vue&type=script&lang=js"
export * from "./bankInfo.vue?vue&type=script&lang=js"
import style0 from "./bankInfo.vue?vue&type=style&index=0&id=77754d3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77754d3c",
  null
  
)

export default component.exports